<div mat-dialog-content>
  <div class="mt-3">
    <h3>
      Esse cliente já foi ativado nos últimos 14 dias. Deseja continuar com a
      Ativação Espontânea?
    </h3>
    <button
      (click)="confirm()"
      class="btn btn-block mb-2 text-uppercase"
      [ngClass]="'btn-cancel-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()"
    >
      Sim
    </button>
    <button
      [mat-dialog-close]
      class="btn btn-block btn-azul mb-2 text-uppercase"
      [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()"
    >
      Não
    </button>
  </div>
</div>
